import React from 'react';
import ScrollableContentLayout from '../layouts/ScrollableContentLayout';
import { useAuth } from '../contexts/AuthContext';
import Hero from '../components/page-components/landing/Hero';
import TrustStrip from '../components/page-components/landing/TrustStrip';
import HowItWorks from '../components/page-components/landing/HowItWorks';
import FeatureGrid from '../components/page-components/landing/FeatureGrid';
import TutorQuality from '../components/page-components/landing/TutorQuality';
import Testimonials from '../components/page-components/landing/Testimonials';
import Faq from '../components/page-components/landing/Faq';
import FinalCta from '../components/page-components/landing/FinalCta';

const LandingPage: React.FC = () => {
  const { authState } = useAuth();
  const ctaHref = authState.isAuthenticated ? '/home' : '/authenticate?mode=signup';

  return (
    <ScrollableContentLayout>
      <Hero ctaHref={ctaHref} />
      <TrustStrip />
      <HowItWorks />
      <FeatureGrid />
      <TutorQuality />
      <Testimonials />
      <Faq />
      <FinalCta ctaHref={ctaHref} />
    </ScrollableContentLayout>
  );
};

export default LandingPage;
